import React from "react";
import './../css/progress.css';

export const Progress = () => {
    return (
        <div className="progress checkout-progress-bar progress-100">
            <div className="indeterminate"></div>
        </div>
    )
}